
<template>

    <div>

        <b-row>

            <b-col md="2">

            <i @click="toggleViz" class="fa fa-arrow-left" style="font-size: 19px;">&nbsp; Utter</i>

            </b-col>

            <b-col>
 
                <div v-if="!collapsed && !toAdd">

                    <b-row class="bg-dark">

                        <b-col>

                            <b-form>

                                <b-form-group
                                    label="Display Text"
                                    label-for="displayText"
                                    class="mb-0"
                                    description="This is the text that will be returned to
                                    the user"
                                >

                                <b-form-textarea
                                    v-model="actionData.action_data"
                                    placeholder="Utterance"
                                    rows="5"
                                    @change="dataChangedEvent()"
                                ></b-form-textarea>

                                </b-form-group>

                            </b-form>

                        </b-col>
                       
                    </b-row>

                    <b-row>

                        <b-card title="Alternatives" class="bg-dark" style="width:100%; margin-top: 9px;">

                            <p v-if="alternativesData.length<1 || !alternativesData">
                                      No alternatives have been added yet, click
                                      the add button to create an alternative. Alternatives enable your bot to respond dynamically
                                        to user input and in different ways.
                            </p>

                            
                                <div v-for="(alternative, idx) in alternativesData" :key="idx" style="margin: 7px;">

                                    <b-row>

                                        <b-col>
                                            <b-form-textarea @change="dataChangedEvent()" v-model="alternative.text" placeholder="text"></b-form-textarea>
                                        </b-col>

                                        <b-col lg="2">
                                            <b-form-select 
                                                id="input-3" 
                                                v-model="alternative.language" 
                                                :options="languages" 
                                                required 
                                                value-field="code"
                                                text-field="name"
                                                @change="dataChangedEvent()"
                                            ></b-form-select>
                                        </b-col>

                                     

                                        <b-col>
                                          <b-button
                                            @click="
                                              deleteAlternative(
                                                idx
                                              )
                                            "
                                            >Delete</b-button
                                          >
                                        </b-col>

                                        </b-row>

                                    </div>

                                        


                                        <b-card-footer class="bg-dark">
                                <b-button
                                  @click="initAddAlternative"
                                  variant="primary"
                                  >Add Alternative</b-button
                                ></b-card-footer>
                        
                        </b-card>


                    </b-row>

                    <b-row>

                        <b-card title="Conditions" class="bg-dark" style="width:100%; margin-top: 9px;">

                            <p v-if="!conditionsData.length>0">
                                      No conditions have been added yet, click
                                      the add button to create a condition for
                                      this action
                                    </p>

                            <ul>
                                <li v-for="(condition, idx) in conditionsData" :key="idx">
                                    
                                    <b-row>

                                        <b-col
                                          class="bg-dark"
                                          style="height: 43px"
                                        >
                                          <span>
                                            {{idx + 1}}. Type:
                                            <b>{{
                                              condition.condition_type
                                            }}</b>
                                          </span>
                                        </b-col>

                                        <b-col
                                          class="bg-dark"
                                          style="height: 43px"
                                        >
                                          <span>
                                            Slot:
                                            <b>{{ condition.slot }}</b>
                                          </span>
                                        </b-col>

                                        <b-col
                                          class="bg-dark"
                                          style="height: 43px"
                                        >
                                          <span v-if="condition.value">
                                            <b>
                                              Value:
                                              {{ condition.value }}</b
                                            >
                                          </span>
                                        </b-col>

                                        <b-col>
                                          <b-button
                                            @click="
                                              deleteCondition(
                                                idx
                                              )
                                            "
                                            >Delete</b-button
                                          >
                                        </b-col>

                                    </b-row>
                                </li>
                            </ul>

                            <b-card-footer class="bg-dark">
                                <b-button
                                  @click="initAddCondition"
                                  variant="primary"
                                  >Add Condition</b-button
                                ></b-card-footer>
                        </b-card>

                    </b-row>

                    <b-row>

                        <b-card title="Values" class="bg-dark" style="width:100%; margin-top: 9px;">

                            <p v-if="!valuesData.length>0">
                                No values have been added yet, click
                                the add button to create a value for
                                this action
                            </p>

                            <ul>
                                <li v-for="(value, idx) in valuesData" :key="idx">
            
                                    <b-row>

                                        <b-col
                                            class="bg-dark"
                                            style="height: 43px"
                                        >
                                            <span>
                                                Slot:
                                                <b>{{ value.slot }}</b>
                                            </span>
                                        </b-col>

                                        <b-col
                                            class="bg-dark"
                                            style="height: 43px"
                                        >
                                            <span v-if="value.symbol">
                                            <b>
                                                Value:
                                                {{ value.symbol }}</b
                                                >
                                            </span>
                                        </b-col>

                                        <b-col>
                                            <b-button
                                            @click="
                                            deleteValue(
                                                idx
                                            )
                                            "
                                            >Delete</b-button
                                            >
                                        </b-col>

                                    </b-row>
                                </li>
                            </ul>

                            <b-card-footer class="bg-dark">
                                <b-button
                                    @click="initAddValue"
                                    variant="primary"
                                    >Add Value</b-button
                                ></b-card-footer>
                            </b-card>

                        </b-row>

                   

                    

                </div>

                <div v-if="toAdd && !collapsed && !toAddValue">

                    <h4>Add Condition</h4>
                    <b-form-group
                        id="input-group-1"
                        label="Slot:"
                        label-for="input-1"
                        description="Slot"
                    >
                    <b-form-select
                        id="input-1"
                        v-model="new_condition.slot"
                        value-field="name"
                        text-field="name"
                        :options="getNonDefaultSlots()"
                        required
                    ></b-form-select>
                    </b-form-group>

                    <b-form-group
                        id="input-group-2"
                        label="Type:"
                        label-for="input-2"
                        description="Condition Type"
                    >
                        <b-form-select
                                id="input-3"
                                v-model="new_condition.condition_type"
                                :options="conditionTypes"
                                required
                        ></b-form-select>
                    </b-form-group>

                    <b-form-group
                        id="input-group-3"
                        label="Value:"
                        label-for="input-3"
                        description="Your condition value"
                        v-if="new_condition.condition_type == 'slot_value_in_list'"
                    >
                        <b-form-input
                            id="input-3"
                            v-model="new_condition.value"
                            required
                        ></b-form-input>
                    </b-form-group>

                    <b-form-group
                        id="input-group-3"
                        label="Value:"
                        label-for="input-3"
                        description="Your condition value"
                        v-if="new_condition.condition_type == 'slot_value_equal_to'"
                    >
                    <b-form-input
                        id="input-3"
                        v-model="new_condition.value"
                        required
                        ></b-form-input>
                    </b-form-group>

        <b-row>

            <b-col>

                <b-button
                    :disabled="!new_condition.slot"
                    @click="addCondition"
                    variant="primary"
                    style="width: 100%"
                >Save</b-button
                >

            </b-col>

            <b-col>
                <b-button
                  @click="toAdd = false"
                  style="width: 100%"
                  variant="danger"
                  >Cancel</b-button
                >
            </b-col>

        </b-row>

        
      </div>





      <div v-if="toAddValue && !collapsed && !toAdd">

            <h4>Add Value</h4>
            <b-form-group
                id="input-group-1"
                label="Slot:"
                label-for="input-1"
                description="Slot"
            >
                <b-form-select
                    id="input-1"
                    v-model="new_value.slot"
                    value-field="name"
                    text-field="name"
                    :options="getNonDefaultSlots()"
                    required
                ></b-form-select>
            </b-form-group>

            <b-form-group
                id="input-group-3"
                label="Placeholder:"
                label-for="input-3"
                description="Your value placeholder"
            >
                <b-form-input
                    id="input-3"
                    v-model="new_value.symbol"
                    required
                ></b-form-input>
            </b-form-group>


        <b-row>

            <b-col>

                <b-button
                    :disabled="!new_value.slot"
                    @click="addValue"
                    variant="primary"
                    style="width: 100%"
                >Save</b-button>

            </b-col>

            <b-col>
                <b-button
                    @click="toAddValue = false"
                    style="width: 100%"
                    variant="danger"
                    >Cancel</b-button>
            </b-col>

        </b-row>


    </div>




        </b-col>

        </b-row>


       


    </div>
   
  </template>
<script>
export default {
  name: 'UtterAction',
  props: {
    actionData: {
      type: Object | String
    },
    conditionsData: {
      type: Array | Object,
      default: () => []
    },
    alternativesData: {
      type: Array | Object
    },
    valuesData: {
      type: Array | Object
    },
    actionidx: {
      type: Number
    },
    slotsData: {
      type: Array | Object
    },

    dataChangedEvent: {
        type: Function
    },
    languages: {
        type: Array | Object
    }, 
  },
    data() {
        return {
            collapsed: true,
            toAdd: false,
            toAddValue: false,
            new_condition: {
                slot: '',
                condition_type: '',
                value: ''
            },
            new_value: {
                slot: '',
                symbol: ''
            },
            conditionTypes: [
                {
                    text: "is not set",
                    value: "slot_value_unset",
                },
                {
                    text: "Equals",
                    value: "slot_value_equal_to",
                },
                {
                    text: "Is in list",
                    value: "slot_value_in_list",
                },
            ],
        }
    },
  mounted() {
    // console.log('UtterAction mounted');
    this.collapseId = 'action_' + this.actionidx;

    // if actiondata type is string, convert to object

    if (typeof this.actionData === 'string') {
        this.actionData = {
            text: this.actionData,
            language: 'en'
        };
    }

    if(this.actionData.await_input == null){
            this.actionData.await_input = true;
        }

    // console.log('this.collapseId', this.collapseId);
  },
    methods: {
        toggleViz() {
        this.collapsed = !this.collapsed;
        },
        initAddCondition() {
            this.toAdd = true;
            this.new_condition = {
                slot: '',
                condition_type: '',
                value: ''
            }
        },
        initAddValue() {
            this.toAddValue = true;
            this.new_value = {
                slot: '',
                symbol: ''
            }
        },
        addCondition() {
            console.log('addCondition', this.new_condition);
            this.conditionsData.push(this.new_condition);
            this.toAdd = false;
            this.$emit('add-condition');

            this.dataChangedEvent();
        },
        addValue() {
            console.log('addValue', this.new_value);
            this.valuesData.push(this.new_value);
            this.toAddValue = false;
            this.$emit('add-value');

            this.dataChangedEvent();
        },
        initAddAlternative() {
            this.$emit('add-alternative');

            const new_alternative = {
                text: '',
                language: 'en'
            }

            this.alternativesData.push(new_alternative);
        },
        deleteCondition(idx) {
            console.log('deleteCondition', idx);
            this.conditionsData.splice(idx, 1);
            this.$emit('delete-condition', idx);

            this.dataChangedEvent();
        },
        deleteValue(idx) {
            console.log('deleteValue', idx);
            this.valuesData.splice(idx, 1);
            this.$emit('delete-value', idx);

            this.dataChangedEvent();
        },
        deleteAlternative(idx) {
            console.log('deleteAlternative', idx);
            this.alternativesData.splice(idx, 1);
            this.$emit('delete-alternative', idx);

            this.dataChangedEvent();
        },
        getNonDefaultSlots() {
            if (
                this.slotsData == null
            ) {
                return [];
            }

            return this.slotsData.filter(
                (slot) => slot.default !== true
            );
        },
    }
}
</script>